import { Chip } from "@mui/joy";
import { useTranslation } from "react-i18next";

type AdvancedChipProps = {
  size?: "sm" | "md" | "lg";
};

export function AdvancedChip({ size = "md" }: AdvancedChipProps) {
  const { t } = useTranslation();

  const isSmall = size === "sm";

  return (
    <Chip
      color="warning"
      variant="soft"
      size={size}
      sx={{
        fontSize: isSmall ? "0.65rem" : "0.75rem",
        fontWeight: 600,
        ml: 1,
        px: isSmall ? 0.75 : 1,
        py: isSmall ? 0.25 : 0.35,
      }}
    >
      {t("advancedChip.advanced")}
    </Chip>
  );
}
